import { render, staticRenderFns } from "./brandimages.vue?vue&type=template&id=266d51ce&scoped=true&"
import script from "./brandimages.vue?vue&type=script&lang=js&"
export * from "./brandimages.vue?vue&type=script&lang=js&"
import style0 from "./brandimages.vue?vue&type=style&index=0&id=266d51ce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266d51ce",
  null
  
)

export default component.exports